var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"selfDomRef",staticClass:"fetch-more-block"},[(_setup.props.isFetching)?[_vm._t("fetching",function(){return [_c('div',[_vm._v(_vm._s(_setup.TUITranslateService.t("TUIChat.正在加载")))])]})]:[_vm._t("fetchEnd",function(){return [_c('div',[_vm._v(_vm._s(_setup.TUITranslateService.t("TUIChat.加载结束")))])]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }